module.exports = __webpack_public_path__ + "static/media/typeface-logo-dev.8e71ac87.svg";